import { type Draft, type PayloadAction } from '@reduxjs/toolkit'

import { type Notification, type NotificationsSlice } from './types'

const isSameError = (queued: Notification, incoming: Notification): boolean =>
  incoming.type === 'ERROR' && queued.type === 'ERROR' && queued.message === incoming.message

export const pushNotificationReducer = (
  state: Draft<NotificationsSlice>,
  action: PayloadAction<Notification>,
): void => {
  if (state.notifications.some((queued) => isSameError(queued, action.payload))) {
    return
  }

  state.notifications.push(action.payload)
}

export const removeNotificationReducer = (
  state: Draft<NotificationsSlice>,
  action: PayloadAction<string>,
): void => {
  state.notifications = state.notifications.filter(({ id }) => id !== action.payload)
}
